// eslint-disable-next-line es/no-object-assign
const updateObject = (oldObject, ...newValues) => Object.assign({}, oldObject, ...newValues);

export default updateObject;
